import React, { useState, useEffect } from 'react';
import { Box, Container, Grid, Typography, CircularProgress } from '@mui/material';
import SectionHeading from './SectionHeading';
import PricingCard from './PricingCard';
import authService from '../services/authService';
import pricingService from '../services/pricingService';

const PricingSection = () => {
  const [pricingPlans, setPricingPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Check if user is logged in to determine current plan
  const currentUser = authService.getCurrentUser();
  const currentPlanSlug = currentUser?.subscription_plan || null;
  
  // Fetch pricing plans from the API
  useEffect(() => {
    const fetchPricingPlans = async () => {
      try {
        setLoading(true);
        const plans = await pricingService.getPricingPlans();
        setPricingPlans(plans);
      } catch (err) {
        console.error('Failed to load pricing plans:', err);
        setError('Failed to load pricing plans. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchPricingPlans();
  }, []);
  
  if (loading) {
    return (
      <Box component="section" id="pricing" sx={{ py: 8, textAlign: 'center' }}>
        <Container>
          <SectionHeading 
            title="Choose Your Trading Plan" 
            subtitle="Select the plan that fits your trading needs. Upgrade anytime as your portfolio grows."
          />
          <CircularProgress />
        </Container>
      </Box>
    );
  }
  
  if (error) {
    return (
      <Box component="section" id="pricing" sx={{ py: 8 }}>
        <Container>
          <SectionHeading 
            title="Choose Your Trading Plan" 
            subtitle="Select the plan that fits your trading needs. Upgrade anytime as your portfolio grows."
          />
          <Typography color="error" align="center">{error}</Typography>
        </Container>
      </Box>
    );
  }
  
  return (
    <Box component="section" id="pricing" sx={{ py: 8, backgroundColor: 'background.default' }}>
      <Container>
        <SectionHeading 
          title="Choose Your Trading Plan" 
          subtitle="Select the plan that fits your trading needs. Upgrade anytime as your portfolio grows."
        />
        
        <Grid container spacing={4} justifyContent="center">
          {pricingPlans.map((plan, index) => (
            <Grid item key={plan.id || index} xs={12} sm={6} md={4}>
              <PricingCard 
                plan={plan} 
                isCurrentPlan={plan.slug === currentPlanSlug}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default PricingSection;